document.addEventListener('DOMContentLoaded', () => {
    const arBanners = document.querySelectorAll('.banner-line');

    arBanners.forEach(oContainer => {
        const arItems = oContainer.querySelectorAll('.banner-line__item');
        if (arItems.length === 0) return;

        let iCurrentIndex = 0;
        let iTimerId = null;

        oContainer.addEventListener('click', (oEvent) => {
            const oClickedItem = oEvent.target.closest('.banner-line__item');
            if (!oClickedItem) return;

            const sHref = oClickedItem.dataset.href;
            if (sHref) {
                window.location.href = sHref;
            }
        });

        function showItem(iIndex) {
            arItems.forEach((oItem, i) => {
                if (i !== iCurrentIndex) {
                    oItem.classList.remove('banner-line__item--prev');
                }
            });

            arItems[iCurrentIndex].classList.remove('banner-line__item--active');
            arItems[iCurrentIndex].classList.add('banner-line__item--prev');

            iCurrentIndex = iIndex;
            arItems[iCurrentIndex].classList.add('banner-line__item--active');
            arItems[iCurrentIndex].classList.remove('banner-line__item--prev');

            startTimer();
        }

        function startTimer() {
            clearTimeout(iTimerId);

            if (arItems.length <= 1) return;

            const iTimerValue = parseInt(arItems[iCurrentIndex].dataset.timer, 10);

            if (!iTimerValue) return;

            iTimerId = setTimeout(() => {
                const iNextIndex = (iCurrentIndex + 1) % arItems.length;
                showItem(iNextIndex);
            }, iTimerValue * 1000);
        }

        startTimer();
    });
});